import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for Attention Index page */
export default class AttentionIndexOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    run: PropTypes.bool.isRequired
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
      />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Audience Attention Index!<br/><br/>Use the buttons at the top of the page to toggle between the 3 rankers: Anticipation, Top and Trending.</p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      },
      {
        ...common,
        content: (<p>The Anticipation Index highlights the content that audiences are looking forward to most during the week measured.</p>),
        target: '#anticipationHeading'
      },
      {
        ...common,
        content: (<p>The Top Index reflects which titles have the highest volume of attention during the week measured.</p>),
        target: '#topHeading'
      },
      {
        ...common,
        content: (<p>The Trending Index reflects the titles with the highest week-over-week jump in attention.<br/><br/>Let's Go!</p>),
        target: '#trendingHeading'
      }
    ]

    return steps
  }
}
